"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    eq: function (a, b) { return a === b; },
    neq: function (a, b) { return a !== b; },
    gt: function (a, b) { return a > b; },
    gte: function (a, b) { return a >= b; },
    lt: function (a, b) { return a < b; },
    lte: function (a, b) { return a <= b; },
    contains: function (a, b) {
        return a.indexOf(b) !== -1;
    },
    startsWith: function (a, b) {
        return a.lastIndexOf(b, 0) === 0;
    },
    endsWith: function (a, b) {
        var pos = a.length - b.length, lastIndex = a.indexOf(b, pos);
        return lastIndex !== -1 && lastIndex === pos;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/filter.js
// module id = 134
// module chunks = 0 1 2 3 4 5 6